import { render, staticRenderFns } from "./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=template&id=ec1f8d6e&"
import script from "./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=script&lang=js&"
export * from "./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/uat.mediaworkflow.winnipeg.ca/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ec1f8d6e')) {
      api.createRecord('ec1f8d6e', component.options)
    } else {
      api.reload('ec1f8d6e', component.options)
    }
    module.hot.accept("./RelatedDeliverablesSocialMediaGrouped.vue?vue&type=template&id=ec1f8d6e&", function () {
      api.rerender('ec1f8d6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/components/deliverables/RelatedDeliverablesSocialMediaGrouped.vue"
export default component.exports